/** 对象存储（Web / Webview 共用） */
export interface CosConfig {
  mainBucket: string;
  mainBucketRegion: string;
  mainCDN: string;
  tplBucket: string;
  tplBucketRegion: string;
  tplCDN: string;
}

export const cosDevelopment: CosConfig = {
  mainBucket: "furries-dev-1303975902",
  mainBucketRegion: "ap-guangzhou",
  mainCDN: "https://furries-dev-1303975902.cos.ap-guangzhou.myqcloud.com",
  tplBucket: "dev-template-1303975902",
  tplBucketRegion: "ap-guangzhou",
  tplCDN: "https://dev-template-1303975902.cos.ap-guangzhou.myqcloud.com",
};

export const cosTest: CosConfig = {
  mainBucket: "furries-dev-1303975902",
  mainBucketRegion: "ap-guangzhou",
  mainCDN: "https://furries-dev-1303975902.cos.ap-guangzhou.myqcloud.com",
  tplBucket: "dev-template-1303975902",
  tplBucketRegion: "ap-guangzhou",
  tplCDN: "https://dev-template-1303975902.cos.ap-guangzhou.myqcloud.com",
};

export const cosProduction: CosConfig = {
  mainBucket: "furries-1303975902",
  mainBucketRegion: "ap-guangzhou",
  mainCDN: "https://oss.furries.cn",
  tplBucket: "furries-template-1303975902",
  tplBucketRegion: "ap-guangzhou",
  tplCDN: "https://tpl.oss.furries.cn",
};
